module.exports = __webpack_public_path__ + "img/Programmatic_64x64.153cea17.png";